import axios from "axios";

const getPermissions = async () => {
  const baseUrl = process.env.REACT_APP_API_URL;

  try {
    const response = await axios.get(`${baseUrl}/api/permission/`);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Terjadi kesalahan saat memuat data");
    }
  }
};

const getMenuPermissionsAction = async () => {
  const baseUrl = process.env.REACT_APP_API_URL;

  try {
    const response = await axios.get(`${baseUrl}/api/permission/view`);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Terjadi kesalahan saat memuat data");
    }
  }
};

const updatePermission = async (id, body) => {
  const baseUrl = process.env.REACT_APP_API_URL;
  return axios.put(`${baseUrl}/api/permissions/${id}`, body)
    .then(res => res.data);
};

const createPermission = async (body) => {
  const baseUrl = process.env.REACT_APP_API_URL;
  return axios.post(`${baseUrl}/api/permission`, body) .then(res => res.data);
};

const deletePermission = async (id) => {
  try {
    const baseUrl = process.env.REACT_APP_API_URL;
    const response = await axios.delete(`${baseUrl}/api/permission/${id}`);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Terjadi kesalahan saat hapus data");
    }
  }
};

export {
  getPermissions,
  updatePermission,
  createPermission,
  getMenuPermissionsAction,
  deletePermission
};
